import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { FormularService } from 'src/app/Services/formular.service';
import { GipUserProcessStatForm } from 'src/app/workflow/user/gipUserReg/gipUserReg.model';

@Component({
  selector: 'app-gip-user-process-stat-form',
  templateUrl: './gipUserProcessStatForm.component.html',
  styleUrls: ['./gipUserProcessStatForm.component.css']
})
export class GipUserProcessStatFormComponent implements OnInit {

  constructor(private shareData: SharingDataService,
    public formularService: FormularService,
   ) { }

  modelInput = GipUserProcessStatForm;
  resourceDefinition;

  formular = [
    { formControlName: "OBJECTID", hidden: true, required: true, inputString: true },
    { formControlName: "FULLNAME", readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "LOGIN", readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "TEXT", readonly: true, editReadonly: true, newReadonly: true, inputString: true },
  ];

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
  }

}
